import React from 'react';
import Ankush from '../assets/images/Ankush.jpg';

const DentistProfile = () => {
  return (
    <div className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 md:pr-12 mb-8 md:mb-0">
            <h2 className="text-3xl md:text-4xl font-bold font-heading mb-4">
              Dr Ankush Vij BDS (Hons)
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              With more than 7 years of experience caring for patients in Manchester, Ankush combines technical expertise with genuine compassion. From urgent toothaches to unexpected accidents, he's at the forefront of dental emergencies—offering swift relief and a clear path forward. Ankush's goal is simple: to put patients at ease, restore comfort, and help everyone maintain a healthy, happy smile for years to come.
            </p>
          </div>
          
          <div className="md:w-1/2 p-32">
            <img 
              src={Ankush} 
              alt="Dr Ankush Vij" 
              className="rounded-lg shadow-lg w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DentistProfile;
